import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { WarningOutlined } from '@ant-design/icons'
import { Space, Tooltip } from 'antd'
import { filter, isEmpty, isNil, join, keys, map, reduce } from 'lodash'

import { useQueryParams } from '../../../core/hooks'
import { areSameValue } from '../../../core/utils'

import { PAGINATION } from '../../../common/constants'

import { TIER } from '../../constants'
import { dishPropType } from '../../prop-types'

const DishIdAndErrorCell = ({ dish }) => {
  const { buildQueryParams } = useQueryParams()

  const { id: dishId } = dish

  const isLikelyToHaveAnError = useMemo(
    () => dish.certainty === 0 || areSameValue(dish.tier, TIER.TWO),
    [dish.certainty, dish.tier],
  )

  const dishErrors = useMemo(
    () =>
      isLikelyToHaveAnError
        ? join(
            reduce(
              keys(dish.aiSuggestion),
              (acc, key) => {
                if (isNil(dish.aiSuggestion[key])) {
                  return acc
                }

                const { messages } = dish.aiSuggestion[key]

                return [
                  ...acc,
                  ...map(
                    filter(messages, message => !isNil(message)),
                    'message',
                  ),
                ]
              },
              [],
            ),
            ', ',
          )
        : '',
    [dish.aiSuggestion, isLikelyToHaveAnError],
  )

  const newPath = useMemo(
    () =>
      buildQueryParams({
        dishIds: [dishId],
        shouldScrollToDish: true,
        currentPage: PAGINATION.DEFAULT_PAGE,
      }),
    [buildQueryParams, dishId],
  )

  return (
    <Space>
      {!isEmpty(dishErrors) && (
        <Tooltip title={dishErrors}>
          <WarningOutlined />
        </Tooltip>
      )}
      <Link to={newPath}>{dishId}</Link>
    </Space>
  )
}

DishIdAndErrorCell.propTypes = {
  dish: dishPropType.isRequired,
}

export default DishIdAndErrorCell
